import { DefaultValueResolver, fetchDefaultObjects } from './helpers'

export const primitiveResolver: DefaultValueResolver = async (
  activityModel,
  context
) => {
  const defaultObjects = await fetchDefaultObjects(context.filteractionUuid)

  const firstObject = defaultObjects[0]
  if (!firstObject?.des) return null

  return {
    uuid_activity_model: activityModel.uuid,
    des: String(firstObject.des)
  }
}
